/**
 * Traducciones para la aplicación C&M Publicaciones
 * ES = Español (Argentina) - Idioma predeterminado
 * PT = Português (Brasil)
 */

export const translations = {
  // ============== NAVBAR ==============
  navbar: {
    inicio: { es: 'Inicio', pt: 'Início' },
    talleres: { es: 'Talleres', pt: 'Oficinas' },
    capacitaciones: { es: 'Capacitaciones', pt: 'Capacitações' },
    iniciarSesion: { es: 'Iniciar sesión', pt: 'Entrar' },
    suscribirse: { es: 'Suscribirse', pt: 'Assinar' },
    miPanel: { es: 'Mi Panel', pt: 'Meu Painel' },
    notificaciones: { es: 'Notificaciones', pt: 'Notificações' },
    configuracion: { es: 'Configuración', pt: 'Configurações' },
    cerrarSesion: { es: 'Cerrar sesión', pt: 'Sair' },
  },

  // ============== HOMEPAGE ==============
  home: {
    // Hero
    tagline: { es: 'Tu Biblioteca en línea', pt: 'Sua Biblioteca online' },
    heroDescription: { 
      es: 'Accedé a nuestros servicios de gestoría y de visualización para toda la documentación técnica que tu taller necesita, a través de nuestra plataforma. Gestionamos tus trámites, tus manuales, boletines de servicio, directivas de aeronavegabilidad y más.', 
      pt: 'Acesse nossos serviços de assessoria e de visualização para toda a documentação técnica que sua oficina precisa, através de nossa plataforma. Gerenciamos seus trâmites, seus manuais, boletins de serviço, diretrizes de aeronavegabilidade e mais.' 
    },
    comenzarAhora: { es: 'Comenzar ahora', pt: 'Começar agora' },
    verTalleres: { es: 'Ver talleres suscriptos', pt: 'Ver oficinas assinantes' },
    
    // Features section
    todoEnUnLugar: { es: 'Todo lo que necesitas en un solo lugar', pt: 'Tudo o que você precisa em um só lugar' },
    docTecnica: { es: 'Documentación técnica siempre al día para tu mantenimiento aeronáutico', pt: 'Documentação técnica sempre atualizada para sua manutenção aeronáutica' },
    manualesTecnicos: { es: 'Manuales Técnicos', pt: 'Manuais Técnicos' },
    manualesDesc: { es: 'Accede a tus manuales de vuelo, servicio, catálogos de partes y más según tu capacidad de operaciones.', pt: 'Acesse seus manuais de voo, serviço, catálogos de peças e mais conforme sua capacidade de operações.' },
    directivasAD: { es: 'Directivas AD', pt: 'Diretivas AD' },
    directivasDesc: { es: 'Recibe alertas automáticas de directivas de aeronavegabilidad aplicables a tus capacidades.', pt: 'Receba alertas automáticos de diretrizes de aeronavegabilidade aplicáveis às suas capacidades.' },
    boletinesServicio: { es: 'Boletines de Servicio', pt: 'Boletins de Serviço' },
    boletinesDesc: { es: 'Mantén tu flota actualizada con los últimos boletines e instrucciones de servicio.', pt: 'Mantenha sua frota atualizada com os últimos boletins e instruções de serviço.' },
    
    // Inspirational section
    tuDocumentacion: { es: 'Tu documentación técnica,', pt: 'Sua documentação técnica,' },
    siempreAMano: { es: 'siempre a mano', pt: 'sempre à mão' },
    inspirationalText: { 
      es: 'Ya sea desde tu taller, tu oficina o mientras disfrutas un café, C&M Servicios Aeronáuticos te brinda acceso instantáneo a través de nuestra plataforma de gestión de la información, a toda la documentación necesaria para mantener tu flota en perfectas condiciones.\n\nBrindamos soluciones de software para que experimentes de la mejor manera la gestión de tu taller.', 
      pt: 'Seja da sua oficina, escritório ou enquanto toma um café, C&M Serviços Aeronáuticos oferece acesso instantâneo através de nossa plataforma de gestão da informação, a toda documentação necessária para manter sua frota em perfeitas condições.\n\nFornecemos soluções de software para que você experimente da melhor forma a gestão da sua oficina.' 
    },
    acceso247: { es: 'Acceso 24/7 desde cualquier dispositivo', pt: 'Acesso 24/7 de qualquer dispositivo' },
    docActualizada: { es: 'Tu documentación siempre al día', pt: 'Sua documentação sempre atualizada' },
    busquedaRapida: { es: 'Búsqueda rápida por modelo o fabricante', pt: 'Busca rápida por modelo ou fabricante' },
    notifDirectivas: { es: 'Notificaciones de nuevas directivas', pt: 'Notificações de novas diretivas' },
    
    // Pricing section
    planesSuscripcion: { es: 'Planes de Suscripción', pt: 'Planos de Assinatura' },
    eligePlan: { es: 'Elige el plan que mejor se adapte a tu taller', pt: 'Escolha o plano que melhor se adapta à sua oficina' },
    masPopular: { es: 'Más popular', pt: 'Mais popular' },
    elegirPlan: { es: 'Elegir plan', pt: 'Escolher plano' },
    
    // Plan features
    statusReport: { es: 'Status Report', pt: 'Status Report' },
    estandar: { es: 'Standard', pt: 'Standard' },
    premium: { es: 'Premium', pt: 'Premium' },
    gratis: { es: 'GRATIS', pt: 'GRÁTIS' },
    mes: { es: 'mes', pt: 'mês' },
    conDebitoAuto: { es: 'con débito automático', pt: 'com débito automático' },
    promoTiempoLimitado: { es: 'Promoción válida por tiempo limitado', pt: 'Promoção válida por tempo limitado' },
    
    // Plan features list
    usuarioPorTaller: { es: '1 usuario por taller', pt: '1 usuário por oficina' },
    verEstadoDocs: { es: 'Ver estado de tus documentos', pt: 'Ver status dos seus documentos' },
    solicitarCompra: { es: 'Asesoramiento para la adquisición de documentación técnica', pt: 'Assessoria para aquisição de documentação técnica' },
    notifActualizaciones: { es: 'Notificaciones de actualizaciones', pt: 'Notificações de atualizações' },
    dosUsuarios: { es: '2 usuarios', pt: '2 usuários' },
    verImprimirDocs: { es: 'Digitalización para ver e imprimir tus documentos', pt: 'Digitalização para ver e imprimir seus documentos' },
    comprarManuales: { es: 'Asesoramiento para la adquisición de manuales adicionales', pt: 'Assessoria para aquisição de manuais adicionais' },
    accesoBoletines: { es: 'Acceso a tus boletines y directivas', pt: 'Acesso aos seus boletins e diretivas' },
    cincoUsuarios: { es: '5 usuarios', pt: '5 usuários' },
    diezUsuarios: { es: '10 usuarios', pt: '10 usuários' },
    usuariosIlimitados: { es: 'Hasta 10 usuarios', pt: 'Até 10 usuários' },
    accesoTotal: { es: 'Documentos de tus capacidades ANAC', pt: 'Documentos das suas capacidades ANAC' },
    verImprimir: { es: 'Ver e imprimir documentación técnica', pt: 'Ver e imprimir documentação técnica' },
    soportePrioritario: { es: 'Soporte prioritario', pt: 'Suporte prioritário' },
    
    // Workshops section
    talleresSuscriptos: { es: 'Talleres Suscriptos', pt: 'Oficinas Assinantes' },
    confianEnNosotros: { es: 'Confían en C&M Servicios Aeronáuticos', pt: 'Confiam na C&M Serviços Aeronáuticos' },
    proximamente: { es: 'Próximamente', pt: 'Em breve' },
    noHayTalleres: { es: 'No hay talleres registrados en', pt: 'Não há oficinas registradas em' },
    
    // Courses section
    formacionProfesional: { es: 'Formación Profesional', pt: 'Formação Profissional' },
    capacitacionAero: { es: 'Capacitación profesional aeronáutica', pt: 'Capacitação profissional aeronáutica' },
    verTodos: { es: 'Ver todos', pt: 'Ver todos' },
    verDetalles: { es: 'Ver detalles', pt: 'Ver detalhes' },
    consultar: { es: 'Consultar', pt: 'Consultar' },
    
    // Institutions section
    instituciones: { es: 'Instituciones y Enlaces de Interés', pt: 'Instituições e Links de Interesse' },
    
    // Footer
    contacto: { es: 'Contacto', pt: 'Contato' },
    ubicacion: { es: 'Ubicación', pt: 'Localização' },
    accesosRapidos: { es: 'Accesos Rápidos', pt: 'Acessos Rápidos' },
    solicitarSuscripcion: { es: 'Solicitar Suscripción', pt: 'Solicitar Assinatura' },
    footerDescription: { 
      es: 'Tu biblioteca aeronáutica en línea. Documentación técnica al día para talleres de mantenimiento aeronáutico de Argentina, Brasil, Uruguay y toda Latinoamérica.', 
      pt: 'Sua biblioteca aeronáutica online. Documentação técnica atualizada para oficinas de manutenção aeronáutica da Argentina, Brasil, Uruguai e toda América Latina.' 
    },
    derechosReservados: { es: 'Todos los derechos reservados.', pt: 'Todos os direitos reservados.' },
    desarrolladoPor: { es: 'Desarrollado por', pt: 'Desenvolvido por' },
  },

  // ============== TALLERES PAGE ==============
  talleres: {
    titulo: { es: 'Talleres Suscriptos', pt: 'Oficinas Assinantes' },
    subtitulo: { es: 'Talleres aeronáuticos certificados que confían en C&M Servicios Aeronáuticos', pt: 'Oficinas aeronáuticas certificadas que confiam na C&M Serviços Aeronáuticos' },
    buscarPlaceholder: { es: 'Buscar por nombre o número ANAC...', pt: 'Buscar por nome ou número ANAC...' },
    cargando: { es: 'Cargando talleres...', pt: 'Carregando oficinas...' },
    noHayTalleres: { es: 'No hay talleres registrados en', pt: 'Não há oficinas registradas em' },
  },

  // ============== CAPACITACIONES PAGE ==============
  capacitaciones: {
    titulo: { es: 'Formación profesional para personal aeronáutico', pt: 'Formação profissional para pessoal aeronáutico' },
    subtitulo: { es: 'Capacitaciones certificadas para mecánicos, técnicos, pilotos y todo personal de la industria aeronáutica', pt: 'Capacitações certificadas para mecânicos, técnicos, pilotos e todo pessoal da indústria aeronáutica' },
    cargando: { es: 'Cargando capacitaciones...', pt: 'Carregando capacitações...' },
    inscribirme: { es: 'Inscribirme', pt: 'Inscrever-me' },
    verMas: { es: 'Ver más información', pt: 'Ver mais informações' },
    verMenos: { es: 'Ver menos', pt: 'Ver menos' },
    vacantes: { es: 'vacantes', pt: 'vagas' },
    modalidad: { es: 'Modalidad', pt: 'Modalidade' },
    duracion: { es: 'Duración', pt: 'Duração' },
    fechaInicio: { es: 'Fecha de Inicio', pt: 'Data de Início' },
    inscripcionHasta: { es: 'Inscripción hasta', pt: 'Inscrição até' },
    certificacion: { es: 'Certificación', pt: 'Certificação' },
    objetivos: { es: 'Objetivos', pt: 'Objetivos' },
    contenido: { es: 'Contenido', pt: 'Conteúdo' },
    requisitos: { es: 'Requisitos', pt: 'Requisitos' },
    docentes: { es: 'Docentes', pt: 'Docentes' },
    titular: { es: 'Titular', pt: 'Titular' },
    suplente: { es: 'Suplente', pt: 'Suplente' },
    porDefinir: { es: 'Por definir', pt: 'A definir' },
    noHayCursos: { es: 'No hay capacitaciones disponibles', pt: 'Não há capacitações disponíveis' },
    noHayCursosDesc: { es: 'Actualmente no hay capacitaciones programadas. Vuelve a consultar pronto o contáctanos para conocer las próximas fechas.', pt: 'Atualmente não há capacitações programadas. Volte em breve ou entre em contato para conhecer as próximas datas.' },
    contactar: { es: 'Contactar', pt: 'Contatar' },
    // Modal inscripción
    inscripcionTitulo: { es: 'Inscripción a Capacitación', pt: 'Inscrição em Capacitação' },
    nombreCompleto: { es: 'Nombre Completo', pt: 'Nome Completo' },
    dni: { es: 'DNI', pt: 'CPF' },
    email: { es: 'Email', pt: 'E-mail' },
    arancel: { es: 'Arancel', pt: 'Taxa' },
    confirmarInscripcion: { es: 'Confirmar Inscripción', pt: 'Confirmar Inscrição' },
    procesando: { es: 'Procesando...', pt: 'Processando...' },
    completeCampos: { es: 'Por favor complete todos los campos', pt: 'Por favor preencha todos os campos' },
    inscripcionExitosa: { es: '¡Inscripción realizada correctamente!', pt: 'Inscrição realizada com sucesso!' },
  },

  // ============== SUSCRIPCION PAGE ==============
  suscripcion: {
    titulo: { es: 'Solicitar Suscripción', pt: 'Solicitar Assinatura' },
    subtitulo: { es: 'Completa el formulario para solicitar acceso a C&M Servicios Aeronáuticos', pt: 'Preencha o formulário para solicitar acesso a C&M Serviços Aeronáuticos' },
    nivelSuscripcion: { es: 'Nivel de Suscripción', pt: 'Nível de Assinatura' },
    datosEmpresa: { es: 'Datos de la Empresa', pt: 'Dados da Empresa' },
    razonSocial: { es: 'Razón Social', pt: 'Razão Social' },
    nombreTaller: { es: 'Nombre del taller', pt: 'Nome da oficina' },
    numeroAnac: { es: 'Número ANAC', pt: 'Número ANAC' },
    pais: { es: 'País', pt: 'País' },
    provincia: { es: 'Provincia/Departamento', pt: 'Estado' },
    seleccionar: { es: 'Seleccionar...', pt: 'Selecionar...' },
    datosContacto: { es: 'Datos de Contacto', pt: 'Dados de Contato' },
    nombreContacto: { es: 'Nombre de Contacto', pt: 'Nome do Contato' },
    nombreCompleto: { es: 'Nombre completo', pt: 'Nome completo' },
    email: { es: 'Email', pt: 'E-mail' },
    telefono: { es: 'Teléfono', pt: 'Telefone' },
    notasAdicionales: { es: 'Notas adicionales', pt: 'Notas adicionais' },
    notasPlaceholder: { es: 'Información adicional que quieras compartir...', pt: 'Informações adicionais que deseja compartilhar...' },
    enviarSolicitud: { es: 'Enviar Solicitud', pt: 'Enviar Solicitação' },
    enviando: { es: 'Enviando...', pt: 'Enviando...' },
    terminosCondiciones: { es: 'Términos y Condiciones', pt: 'Termos e Condições' },
    aceptoTerminos: { es: 'He leído y acepto los', pt: 'Li e aceito os' },
    debesAceptar: { es: 'Debes aceptar los términos y condiciones para continuar', pt: 'Você deve aceitar os termos e condições para continuar' },
    alertaPago: { es: 'Una vez enviada la solicitud, nos pondremos en contacto para coordinar el pago y completar la suscripción.', pt: 'Após enviar a solicitação, entraremos em contato para coordenar o pagamento e completar a assinatura.' },
    // Planes
    statusReportDesc: { es: '1 usuario, ver estado de documentos', pt: '1 usuário, ver status de documentos' },
    estandarDesc: { es: '2 usuarios, ver/imprimir docs de tus capacidades', pt: '2 usuários, ver/imprimir docs de suas capacidades' },
    estandarPromo: { es: 'Con débito automático', pt: 'Com débito automático' },
    premiumDesc: { es: 'Hasta 10 usuarios, documentos de tus capacidades, ver e imprimir', pt: 'Até 10 usuários, documentos das suas capacidades, ver e imprimir' },
    // Confirmación
    solicitudEnviada: { es: '¡Verifica tu Email!', pt: 'Verifique seu Email!' },
    solicitudDesc: { es: 'Te enviamos un email de verificación. Por favor revisa tu bandeja de entrada y haz clic en el enlace para continuar.', pt: 'Enviamos um email de verificação. Por favor, verifique sua caixa de entrada e clique no link para continuar.' },
    revistaSpam: { es: '¿No lo encuentras? Revisa tu carpeta de spam.', pt: 'Não encontrou? Verifique sua pasta de spam.' },
    volverInicio: { es: 'Volver al inicio', pt: 'Voltar ao início' },
  },

  // ============== LOGIN PAGE ==============
  login: {
    titulo: { es: 'Iniciar Sesión', pt: 'Entrar' },
    subtitulo: { es: 'Ingresa tus credenciales para acceder', pt: 'Insira suas credenciais para acessar' },
    email: { es: 'Email', pt: 'E-mail' },
    password: { es: 'Contraseña', pt: 'Senha' },
    ingresar: { es: 'Ingresar', pt: 'Entrar' },
    ingresando: { es: 'Ingresando...', pt: 'Entrando...' },
    recordarEmail: { es: 'Recordar mi email', pt: 'Lembrar meu e-mail' },
    noTienesCuenta: { es: '¿No tienes cuenta?', pt: 'Não tem conta?' },
    solicitaSuscripcion: { es: 'Solicita tu suscripción', pt: 'Solicite sua assinatura' },
    errorCredenciales: { es: 'Error al iniciar sesión. Verifique sus credenciales.', pt: 'Erro ao entrar. Verifique suas credenciais.' },
  },

  // ============== COMMON ==============
  common: {
    cargando: { es: 'Cargando...', pt: 'Carregando...' },
    error: { es: 'Error', pt: 'Erro' },
    exito: { es: 'Éxito', pt: 'Sucesso' },
    guardar: { es: 'Guardar', pt: 'Salvar' },
    cancelar: { es: 'Cancelar', pt: 'Cancelar' },
    eliminar: { es: 'Eliminar', pt: 'Excluir' },
    editar: { es: 'Editar', pt: 'Editar' },
    ver: { es: 'Ver', pt: 'Ver' },
    buscar: { es: 'Buscar', pt: 'Buscar' },
    filtrar: { es: 'Filtrar', pt: 'Filtrar' },
    aplicar: { es: 'Aplicar', pt: 'Aplicar' },
    limpiar: { es: 'Limpiar', pt: 'Limpar' },
    si: { es: 'Sí', pt: 'Sim' },
    no: { es: 'No', pt: 'Não' },
    atras: { es: 'Atrás', pt: 'Voltar' },
    siguiente: { es: 'Siguiente', pt: 'Próximo' },
    anterior: { es: 'Anterior', pt: 'Anterior' },
  },

  // ============== COUNTRIES ==============
  countries: {
    argentina: { es: 'Argentina', pt: 'Argentina' },
    brasil: { es: 'Brasil', pt: 'Brasil' },
    uruguay: { es: 'Uruguay', pt: 'Uruguai' },
    chile: { es: 'Chile', pt: 'Chile' },
    peru: { es: 'Perú', pt: 'Peru' },
    bolivia: { es: 'Bolivia', pt: 'Bolívia' },
    paraguay: { es: 'Paraguay', pt: 'Paraguai' },
  },
};

/**
 * Función helper para obtener traducción
 * @param {object} translationObj - Objeto con {es: '...', pt: '...'}
 * @param {string} language - 'es' o 'pt'
 * @returns {string} - El texto traducido
 */
export const t = (translationObj, language = 'es') => {
  if (!translationObj) return '';
  return translationObj[language] || translationObj.es || '';
};

export default translations;
